import React from 'react';
import { withRouter } from 'react-router-dom';
import Heading from 'grommet/components/Heading';
import Table from 'grommet/components/Table';
import TableRow from 'grommet/components/TableRow';
import TableHeader from 'grommet/components/TableHeader';
import { getCurrencySymbol } from '../../shared/utility';
import RenderPassActionButtons from '../ManagePasses/RenderPassActionButtons/RenderPassActionButtons';

import classes from './VideoOnDemandPasses.module.scss';
import CustomButton from '../../components/CustomButton/CustomButton';

function VideoOnDemandPasses({ videoProducts = [], userVideoProducts = [], history }) {
  return (
    <>
      <div className={classes.header}>
        <Heading tag="h3">Video On Demand</Heading>
      </div>
      {(!!userVideoProducts.length || !!videoProducts.length) && (
        <Table>
          <TableHeader labels={['Name', 'Description', 'Cost', '']} />
          <tbody>
            {userVideoProducts
              .sort((v1, v2) => v1.displayOrder - v2.displayOrder)
              .map((product) => (
                <TableRow key={product._id}>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td>{product.cost ? `${getCurrencySymbol(product.currency)} ${product.cost}` : '-'}</td>
                  <td>
                    <div className={classes.vodAction}>
                      <CustomButton
                        label="View"
                        className={`${classes.passButton} ${product?.status === 'pending' ? classes.disabled : ''}`}
                        onClick={() => {
                          history.push(`/gym/pass/${product._id}`);
                        }}
                      />
                    </div>
                  </td>
                </TableRow>
              ))}
            {videoProducts
              .sort((v1, v2) => v1.displayOrder - v2.displayOrder)
              .map((product) => (
                <TableRow key={product._id}>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td>{product.cost ? `${getCurrencySymbol(product.currency)} ${product.cost}` : '-'}</td>
                  <td>
                    <div className={classes.vodAction}>
                      <RenderPassActionButtons
                        buttonStyle={{ height: '40px' }}
                        classPass={product}
                        classType={product.forClass}
                        editPass={() => {}}
                        label={product.cost ? 'Pay' : 'View'}
                        successMessage={product.cost === 0 && 'Pass added to account'}
                        goBackToPreviousPage={() => {
                          if (product.cost === 0) {
                            history.push(`/gym/pass/${product._id}`);
                          }
                        }}
                      />
                    </div>
                  </td>
                </TableRow>
              ))}
          </tbody>
        </Table>
      )}
    </>
  );
}

export default withRouter(VideoOnDemandPasses);
